module.exports = __webpack_public_path__ + "img/new-object-speech.dd20fb3d.png";